import { ChevronLeft } from '@styled-icons/heroicons-outline/ChevronLeft';
import { ChevronRight } from '@styled-icons/heroicons-outline/ChevronRight';
import { ScrollButtonGroupSchema } from '@/views/sports/components/ScrollButtonGroup/styles/ScrollButtonGroup.styles';

export const scrollButtonGroupStyles: ScrollButtonGroupSchema = {
  iconButtonScrollRightSvg: {
    as: ChevronRight,
    sx: {},
  },
  iconButtonScrollRight: {
    variant: 'secondary',
    w: '17px',
    minW: 'auto',
    h: '9',
  },
  iconButtonScrollLeftSvg: {
    as: ChevronLeft,
    sx: {},
  },
  iconButtonScrollLeft: {
    variant: 'secondary',
    w: '17px',
    minW: 'auto',
    h: '9',
  },
  flexWrapper: {
    bg: 'blackAlpha.400',
    borderRadius: 'md',
    boxShadow:
      '0px 1px 0px 0px rgba(255, 255, 255, 0.10), 0px 3px 5px 0px rgba(0, 0, 0, 0.20) inset',
  },
  buttonGroupSports: {
    display: 'inline-flex',
    flex: '1',
    alignItems: 'center',
    overflowX: 'auto',
    pl: '2',
    spacing: '1',
    overflowY: 'hidden',
    whiteSpace: 'nowrap',
    boxShadow:
      '0px 1px 5px 0px rgba(0, 0, 0, 0.25) inset, 0px 1px 0px 0px rgba(255, 255, 255, 0.10)',
    bg: 'blackAlpha.400',
    borderRadius: 'lg',
    pos: 'relative',
    w: ['120px', 'auto', null],
    sx: { '::-webkit-scrollbar': { display: 'none' } },
    height: '2.5rem',
  },
  buttonGroupScrolls: {
    display: ['none', null, null, 'inline-flex'],
    pos: 'relative',
    px: '1',
    py: '0.5',
    gap: 0.5,
    isAttached: true,
    alignItems: 'center',
    h: '40px',
  },
  scrollIndicator: {
    w: 2,
    h: '0.5',
    bg: 'beta.500',
    pos: 'absolute',
    bottom: 'px',
    transition: 'all 0.2s ease',
  },
};
